/**
 * get color range btw green, warning and danger with dynamic by percent
 * @param percent number : 0 - 100, 0: green, 100: danger
 */
const ltvDynamicColor = (percent: number) => {
  // [percentage, red, green, blue]
  const color = [
    [55, 93, 188, 162], // green (pallet.secondary.main)
    [75, 255, 184, 0], // warning (pallet.warning.main)
    [95, 224, 62, 62], // danger (pallet.danger.main)
  ]

  // defaultColor is green
  const defaultColor = arrayToRGB(color[0].slice(1))

  // If over 3th stop it will be last color (danger)
  if (color[2][0] < percent) return arrayToRGB(color[2].slice(1))

  for (let i = 0; i < color.length; i++) {
    if (color[i][0] >= percent) {
      if (i === 0) return defaultColor

      const c1 = color[i - 1]
      const c2 = color[i]
      const _p = (percent - c1[0]) / (c2[0] - c1[0])

      const r = (c2[1] - c1[1]) * _p + c1[1]
      const g = (c2[2] - c1[2]) * _p + c1[2]
      const b = (c2[3] - c1[3]) * _p + c1[3]

      return `rgb(${r},${g},${b})`
    }
  }
  return defaultColor
}

export default ltvDynamicColor

function arrayToRGB(color: number[]) {
  return `rgb(${color.join(',')})`
}
